import { Review } from '../types/review.type';

/** True when all the views of the review are archived: its reference view is then an archived one */
export const hasOnlyArchivedViews = (
  review: Pick<Review, 'referenceView'>,
): boolean =>
  !review.referenceView?.view ||
  review.referenceView.view.status === 'archived';
